import React from "react";
import BaseSocialButton from "./BaseSocialButton";
import GoogleIcon from "./icons/GoogleIcon";

interface GoogleSocialButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  text?: string;
  loading?: boolean;
}

const GoogleSocialButton: React.FC<GoogleSocialButtonProps> = React.memo(({
  onClick,
  disabled = false,
  className = "",
  text = "Continue with Google",
  loading = false,
}) => {
  return (
    <BaseSocialButton
      onClick={onClick}
      disabled={disabled}
      className={className}
      loading={loading}
      variant="google"
      icon={<GoogleIcon />}
    >
      {text}
    </BaseSocialButton>
  );
});

GoogleSocialButton.displayName = "GoogleSocialButton";

export default GoogleSocialButton;
